// extracted by mini-css-extract-plugin
export default {"signature-wrapper":"SignatureLogo_signature-wrapper__9SnOp"};